import { statusTone } from '../utils/statusTone';
import { Badge } from './Badge';

/**
 * Pastille d'état (crit / anor / norm) : le texte de la cellule, inchangé, sur le fond
 * des jetons KPI (composant Badge, état KPI, taille des cellules) ; le point est décoratif
 * (le texte porte l'information).
 */
export function StatusPill({ tone, children }) {
  return <Badge state={tone} size="md" className="status-pill">{children}</Badge>;
}

/** Texte d'une cellule : en pastille s'il figure au dictionnaire des statuts, sinon tel quel. */
export function StatusText({ text }) {
  const tone = statusTone(text);
  return tone ? <StatusPill tone={tone}>{text}</StatusPill> : text;
}
